export default "__VITE_ASSET__2bd31709__"